import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractAuditDto, AppRoleDto, MaskingDto, MaskingTypeEnum, PermissionDto, PropertyDto, PropertyGroupEnum, RolePermissionEnum, RolePermissionGroupEnum } from '../../service/dto';
import { NzMessageService } from 'ng-zorro-antd/message';
import { HttpPropertyService } from '../../service/http-property.service';
import { map, Observable } from 'rxjs';
import { HttpAuditService } from '../../service/http-audit.service';
import { HttpClearSystemDataService } from '../../service/http-clear-system-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClearAllDataModalComponent } from '../clear-all-data-modal/clear-all-data-modal.component';


@Component({
  selector: 'app-property-list',
  standalone: false,
  templateUrl: './property-list.component.html',
  styleUrl: './property-list.component.scss'
})
export class PropertyListComponent implements OnInit, OnDestroy {
	emailProperties: PropertyDto[] = [];
	thirdPartyProperties: PropertyDto[] = [];
	otpProperties: PropertyDto[] = [];
	agentProperties: PropertyDto[] = [];
	jwtProperties: PropertyDto[] = [];
	dataFileImportProperties: PropertyDto[] = [];
	otherProperties: PropertyDto[] = [];

	selectedTabIndex = 0;
	modifications!: Observable<AbstractAuditDto[]>;

	constructor(
		private service: HttpPropertyService,
		private auditService: HttpAuditService,
		private messageService: NzMessageService,
		private clearSystemDataService: HttpClearSystemDataService,
		private modalService: NgbModal) { }

	ngOnInit(): void {
		this.service.getAll().subscribe(result => this.populate(result));
		this.modifications = this.auditService.getModificationsToProperty(0,1000).pipe(
			map(item => item.records as AbstractAuditDto[])
		);
	}
	ngOnDestroy(): void {

	}
	private populate(input: PropertyDto[]) {
		this.emailProperties = input.filter(item => item.group == 'Email');
		this.thirdPartyProperties = input.filter(item => item.group == 'ThirdParty');
		this.otpProperties = input.filter(item => item.group == 'Otp');
		this.agentProperties = input.filter(item => item.group == 'Agent');
		this.jwtProperties = input.filter(item => item.group == 'Jwt');
		this.dataFileImportProperties = input.filter(item => item.group == 'DataFileImport');
		this.otherProperties = input.filter(item => item.group == 'Other');
	}
	doSubmit() {
		const payload = [
			...this.emailProperties,
			...this.thirdPartyProperties,
			...this.otpProperties,
			...this.agentProperties,
			...this.jwtProperties,
			...this.dataFileImportProperties,
			...this.otherProperties
		]
		this.service.saveProperties(payload).subscribe(result => {
			this.populate(result);
			this.messageService.info("Propeties Saved");
		});
	}
	trackByProperty(index: number, item: PropertyDto): any {
		return item.hashCode;
	}

	// Relocated from the nav sidebar's Operations menu into this page's
	// Danger zone card (GUI-modernisation-brief.md §6) — same OTP-gated
	// confirmation flow, unchanged, just triggered from a different
	// place in the UI.
	clearAllSystemData() {
		this.clearSystemDataService.requestOtp().subscribe(result => {
			this.modalService.open(ClearAllDataModalComponent, { size: 'lg' });
		});
	}
}
